import { createSelector } from 'reselect'
import getGroupPaymentPreviewRequestInfo from './getGroupPaymentPreviewRequestInfo'

export const getSavedGroupPaymentAllocation = (state: App.State) =>
  state.checkout.payment.groupPayment?.allocation

export const getSavedGroupPaymentPreview = (state: App.State) =>
  state.checkout.payment.groupPayment?.preview

export const getSavedGroupPaymentFingerprint = (state: App.State) =>
  state.checkout.payment.groupPayment?.fingerprint

function getMatchingGroupPaymentSummary(
  preview: App.Checkout.GroupPaymentPreviewResult | undefined,
  savedFingerprint: string | undefined,
  currentFingerprint: string | undefined,
): App.Checkout.GroupPaymentPreviewSummary | undefined {
  if (!preview?.summary || !currentFingerprint || savedFingerprint !== currentFingerprint) {
    return undefined
  }
  return preview.summary
}

export const getCurrentSavedGroupPaymentSummary = createSelector(
  getSavedGroupPaymentPreview,
  getSavedGroupPaymentFingerprint,
  getGroupPaymentPreviewRequestInfo,
  (preview, savedFingerprint, requestInfo) =>
    getMatchingGroupPaymentSummary(preview, savedFingerprint, requestInfo?.fingerprint),
)

const getGroupPaymentLeadContributionAmount = createSelector(
  getCurrentSavedGroupPaymentSummary,
  getSavedGroupPaymentAllocation,
  (summary, allocation): number =>
    summary?.leadContributionAmount ?? allocation?.leadContributionAmount ?? 0,
)

export default getGroupPaymentLeadContributionAmount
